/* eslint-disable max-len */
import { useState, useEffect, useCallback, useContext } from 'react';

import { AppContext } from '../../contexts/app';
import api from '../../services/api';

export default function useDashboard() {
  const { setLoading } = useContext(AppContext);
  const [error, setError] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [lastSessao, setLastSessao] = useState(null);
  const [sessoes, setSessoes] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    totalAtivos: 0,
    totalInativos: 0,
    totalLicenciados: 0,
    totalJustificativas: 0,
    totalRenuncias: 0,
    years: [],
    sessoes: [],
  });

  const { totalAtivos, totalInativos, totalLicenciados, totalJustificativas, totalRenuncias, years } = dashboardData;

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/dashboards');
        setDashboardData(data);
        setSessoes(data.sessoes);
        setLastSessao(data?.sessoes?.length ? data.sessoes[data.sessoes.length - 1] : null);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao buscar dados do dashboard:', err);
        if (err?.response?.data?.message) {
          setError(err.response.data.message);
          return;
        }

        setError('Erro ao buscar dados do dashboard');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getSessoesByYear = useCallback((_year = '') => {
    (async () => {
      try {
        setLoading(true);
        setYear(_year);
        const query = new URLSearchParams({
          year: _year,
        });
        const { data } = await api.get(`/dashboards/sessoes-by-year?${query.toString()}`);
        setSessoes(data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error('Erro ao buscar dados do dashboard:', err);
        if (err?.response?.data?.message) {
          setError(err.response.data.message);
          return;
        }

        setError('Erro ao buscar dados do dashboard');
      }
    })();
  }, []);

  return {
    error,
    totalAtivos,
    totalInativos,
    totalLicenciados,
    totalJustificativas,
    totalRenuncias,
    years,
    sessoes,
    lastSessao,
    year,
    getSessoesByYear,
  };
}
